import signer from '@/urls/signer'
import {
  sendGetRequest,
  postFileRequest,
  saveFileRequest, sendPostRequest
} from '@/helper/requests'
import { executeRequest } from '@/store/utils'

const state = {
  signer: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    // next: null,
    // prev: null,
    error: null
  }
}

const getters = {
  getSigner: state => state.signer.items,
  getSignerCount: state => state.signer.count,
  getCurrentUrl: state => state.signer.currentUrl,
  getSignerDetail: state => state.signer.detail,
  // getNext: state => state.signer.next,
  // getPrev: state => state.signer.prev,
  isLoadingSigner: state => state.signer.loading,
  saveSignerError: state => state.signer.error
}

const actions = {
  loadSignerList: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Загружает список документов для подписания
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {string} params.url - URL для загрузки (опционально)
     * @param {Function} params.urlAppend - функция для модификации URL (опционально)
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    if (!url) {
      url = signer.SIGNER.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingSigner) {
      commit('SET_SIGNER_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_SIGNER', data.results)
          commit('SET_SIGNER_COUNT', data.count)
          // commit('SET_SIGNER_NEXT', data['next']);
          // commit('SET_SIGNER_PREV', data['prev']);
          commit('SET_SIGNER_CURRENT_URL', url)
          commit('SET_SIGNER_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_SIGNER_LOADING_END')
          commit('SAVE_SIGNER_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  saveFile: ({ commit, getters }, { id, url, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Сохраняет подписанный файл
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {string|number} params.id - идентификатор документа
     * @param {string} params.url - URL для сохранения (опционально)
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    if (!url) url = signer.SIGNER.DETAIL(id)
    saveFileRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  createSignature: ({ dispatch, commit, getters }, { data, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Создает электронную подпись для документа
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {FormData} params.data - данные для создания подписи
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    const url = signer.SIGNER.CREATE()
    executeRequest('Signer', postFileRequest, { url, data, finalizer, catcher }, { dispatch, commit, getters })
  },
  sendFileToMail: ({ dispatch, commit, getters }, { data, document, recipient, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Отправляет файл по почте
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {Object} params.data - данные для отправки
     * @param {string|number} params.document - идентификатор документа
     * @param {string|number} params.recipient - идентификатор получателя
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    const url = signer.SIGNER.SEND_MAIL(document, recipient)
    executeRequest('Signer', sendPostRequest, { data, url, finalizer, catcher }, { dispatch, commit, getters })
  },
  getApproveHash: ({ dispatch, commit, getters }, { data, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Проверяет целостность документа
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {Object} params.data - данные для проверки
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    const url = signer.SIGNER.DOCUMENTS_CHECK()
    executeRequest('Signer', sendPostRequest, { data, url, finalizer, catcher }, { dispatch, commit, getters })
  },
  sendFileToMailAppendFile: ({ dispatch, commit, getters }, { data, document, recipient, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Отправляет документ с прикрепленным файлом по почте
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {FormData} params.data - данные с файлом
     * @param {string|number} params.document - идентификатор документа
     * @param {string|number} params.recipient - идентификатор получателя
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    const url = signer.SIGNER.SEND_MAIL(document, recipient)
    executeRequest('Signer', postFileRequest, { data, url, finalizer, catcher }, { dispatch, commit, getters })
  },
}

const mutations = {
  SET_SIGNER: (state, items) => {
    /**
     * Устанавливает список документов для подписания
     * @param {Object} state - состояние хранилища
     * @param {Array} items - массив документов
     */
    state.signer.items = items
  },
  SET_SIGNER_COUNT: (state, value) => {
    /**
     * Устанавливает количество документов для подписания
     * @param {Object} state - состояние хранилища
     * @param {number} value - количество документов
     */
    state.signer.count = value
  },
  // SET_NEXT: (state, value) => {
  //   state.signer.next = value
  // },
  // SET_PREV: (state, value) => {
  //   state.signer.prev = value
  // },
  SET_SIGNER_CURRENT_URL: (state, value) => {
    /**
     * Устанавливает URL для пагинации
     * @param {Object} state - состояние хранилища
     * @param {string} value - URL текущего запроса
     */
    state.signer.currentUrl = value
  },
  SET_SIGNER_LOADING: (state) => {
    /**
     * Включает индикатор загрузки документов
     * @param {Object} state - состояние хранилища
     */
    state.signer.loading = true
  },
  SET_SIGNER_LOADING_END: (state) => {
    /**
     * Выключает индикатор загрузки документов
     * @param {Object} state - состояние хранилища
     */
    state.signer.loading = false
  },
  SAVE_SIGNER_ERROR: (state, error) => {
    /**
     * Сохраняет ошибку при работе с электронной подписью
     * @param {Object} state - состояние хранилища
     * @param {Object} error - объект ошибки
     */
    state.signer.error = error
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
